import { inject, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';

@Injectable({
  providedIn: 'root',
})
export class FullscreenService implements OnDestroy {
  private fullscreenSubject = new BehaviorSubject<boolean>(false);

  fullscreen$: Observable<boolean> = this.fullscreenSubject.asObservable();

  readonly #messageErrorResolver = inject(MessageErrorResolver);

  private fullscreenChangeHandler = () => {
    const isFullscreen = !!document.fullscreenElement;
    this.fullscreenSubject.next(isFullscreen);
  };

  constructor() {
    document.addEventListener(
      'fullscreenchange',
      this.fullscreenChangeHandler
    );
  }

  enable(): void {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      elem.requestFullscreen().catch((err) => {
        this.#messageErrorResolver.resolveMessage(err);
      });
    }
  }

  disable(): void {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    }
  }

  toggle(): void {
    if (!document.fullscreenElement) {
      this.enable();
    } else {
      this.disable();
    }
  }

  isFullscreen(): boolean {
    return !!document.fullscreenElement;
  }

  ngOnDestroy(): void {
    document.removeEventListener(
      'fullscreenchange',
      this.fullscreenChangeHandler
    );
  }
}
